
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/les-innovations/[slug]",
      function () {
        return require("private-next-pages/les-innovations/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/les-innovations/[slug]"])
      });
    }
  